import { Checkbox, EventHandler, OutlineButton, PrimaryButton } from "client/CommonComponents";
import permissions, { isAuthorized } from "client/utils/Permissions";
import deleteItem from '../../../../../assets/images/Delete 2 New.svg';
import './MyCart.scss'
import { CONSTANTS } from "client/utils/constants";
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import { formatPrice } from "utils";

const MyCart = (props:any) => {
    const grandTotal  = props?.grandTotal
    const getCartCount = props?.getCartCount
    const onClickDeleteFromCart = props?.onClickDeleteFromCart
    const getRequestLength = props?.getRequestLength
    const requestTypeList = props?.requestTypeList
    const selectedCostCenter = props?.selectedCostCenter
    const BulkOrdeByIdValue = props?.BulkOrdeByIdValue;
    const isCostCenterAvailableForSubmit = props?.isCostCenterAvailableForSubmit

    const renderVehicleDetails = (item:any, itemIndex:any, requestDeleteIndex:any, index:any, requestItem:any, itemVal:any, requestIndex?: any) => {
        return (
            <>
                <div className="header-block">
                    <p className="header-label mt-2">{requestItem.orderRequestSubTypeLabel}</p>
                    <div className="right-block delete-type">                        
                        <div className="controls up-down-image bg-color">
                            <EventHandler onEvent={() => props?.handleCollapseClick(itemIndex, requestIndex, index)} data-attribute="MyCart_Default_EventHandler_5">
                                <div className={`${item.collapse == true && props?.expandAll ? 'up-image fa-angle-up' : 'down-image fa-angle-down'}`}>
                                    <span></span>
                                </div>
                            </EventHandler>
                        </div>
                        <div className="up-down-image">
                            <EventHandler onEvent={(e: any) => onClickDeleteFromCart(e, item, itemIndex, requestDeleteIndex, requestItem)} data-attribute="MyCart_Default_EventHandler_2_2">
                                <img
                                    src={deleteItem}
                                    alt="delete"
                                    className=" editImg me-1"
                                    title="Delete"
                                />
                            </EventHandler>
                        </div>
                    </div>
                </div>
                { item?.collapse && <div className="content-block">
                    <div className='costCenter-type'>
                        <div className="title">Cost Center</div>
                        <div className="desc">{selectedCostCenter?.label || "-"}</div>
                    </div>
                    <div className='make-type'>
                        <div className="title">Make</div>
                        <div className="desc">{item?.make || '-'}</div>
                    </div>
                    <div className='quantity-type'>
                        <div className="title">Quantity</div>
                        <div className="desc">{item?.quantity || '-'}</div>
                    </div>
                    <div className='vehicle-type'>
                        <div className="title">Price</div>
                        <div className="desc">{"$" + formatPrice(item?.price, 2) || '-'}</div>
                    </div>  
                    { props?.expandAll ?                 
                    <>{ itemVal?.type == CONSTANTS?.VEHICLE_REQUEST ? <div className='vehicleSpec-type'>
                        <div className="title">Vehicle Spec</div>
                        <div className="desc">{item?.description || '-'}</div>
                    </div> : <div className='vehicleSpec-type'>
                        <div className="title">Equipment Spec</div>
                        <div className="desc">{item?.description || '-'}</div>
                    </div>
                    }
                    { itemVal?.type == CONSTANTS?.VEHICLE_REQUEST ? <div className='comments-type'>
                        <div className="title">Comments</div>
                        <div className="desc">{item?.comments || '-'}
                        </div>
                    </div> : null
                    }
                    </> : '' }
                </div> }               
            </>
        ) 
    }

    return(<>    
     {requestTypeList?.length ?    
        <div className="vehicle-request-data-container bulk-order-mycart-container">
            
                <div className="header-container">
                    <div className="heading">
                        MY CART ({getCartCount()})
                    </div> 
                    <div className="expand-all">
                        <Checkbox checked={props?.expandAll} className='me-1 mb-0' onChange={props?.handleClickExpandAll}  data-attribute="MyCart_Default_Checkbox_3" /><span className="expand-all-txt">Expand All</span>
                        <span className='fa fa-angle-right'></span>
                    </div> 
                </div>
                <hr />
                {
                    requestTypeList?.length ? requestTypeList?.map((itemVal?: any, itemIndex?: any) => {
                        
                        return(
                            <div>
                            <p className="blueLabel mb-2 mt-3">{(itemVal?.type.toUpperCase())} ({getRequestLength(itemVal?.searchCriteria ) })</p>

                            {
                            itemVal?.searchCriteria?.length ? itemVal?.searchCriteria?.map((requestItem: any, requestIndex: any) => (
                                <>
                                
                                <>{
                                    requestItem?.requests?.map((item:any, index:any)=>(
                                        <div className="vehicle-request-data" key={index}>                   
                                            <div className="details-container" id={index} key={index}>
                                                <div className="vehicle-details-section details-section">                           
                                                    {
                                                        renderVehicleDetails(item,itemIndex,requestItem?.requestIndex,index,requestItem, itemVal, requestIndex)
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }</>           
                                </>
                                )) : ""
                            }
                            </div>
                        )
                    }) : null
                    
                }    
                <div className="grand-order-container mb-3">
                    <span>Order Grand Total</span>
                    <span className='price'>
                    {"$" + formatPrice(grandTotal, 2)}
                    </span>
                </div>  
                <div>
                    <PrimaryButton text='Submit' disabled={!isCostCenterAvailableForSubmit || !isAuthorized(permissions?.CreateUpdateBulkOrder)} className='pull-right' onClick={() => props?.handleClickSubmit("Submit")} data-attribute="MyCart_Default_Button_5" />
                    {(BulkOrdeByIdValue?.orderStatus == "Saved" || !BulkOrdeByIdValue?.hasOwnProperty("orderStatus")) ? <PrimaryButton text='Save' disabled={!isCostCenterAvailableForSubmit || !isAuthorized(permissions?.CreateUpdateBulkOrder)} className='pull-right me-2' onClick={() => props?.handleClickSubmit("Save")} data-attribute="MyCart_Default_Button_6" /> : null}
                    <OutlineButton text='Cancel' className='pull-right me-2' onClick={props?.handleClickCancel} data-attribute="MyCart_Default_Button_7" />
                </div>
            <CompleteConfirmationPopup
                hideDialog={!props?.cancelPopupcontent.isDialogVisible}
                onDismiss={props?.hideDialogCancel}
                Popupcontent={props?.cancelPopupcontent}
                popupOutlinebtnOnclick={() => props?.cancelPopupcontent.popupOutlinebtnOnclick()}
                popupPrimarybtnOnclick={() => props?.cancelPopupcontent.popupPrimarybtnOnclick()}
            />
            <CancelConfirmationPopup
                hideDialog={!props?.Popupcontent.isDialogVisible}
                onDismiss={props?.Popupcontent.popupOutlinebtnOnclick ? props?.Popupcontent.popupOutlinebtnOnclick : props?.hideDialog}
                Popupcontent={props?.Popupcontent}
                popupOutlinebtnOnclick={() => props?.Popupcontent.popupOutlinebtnOnclick()}
                popupPrimarybtnOnclick={() => props?.Popupcontent.popupPrimarybtnOnclick()}
            /> 
 
    </div>
    : null}
    </>
    )
}

export default MyCart;
